import type { MouseEvent } from "react";
import type { MRT_Row } from "material-react-table";
import type { RowActionDescriptor } from "@/components/tables/rowActions/RowActionItem";

export interface RowActionsSlotContext {
  standardActions: RowActionDescriptor[];
  requestReload: () => void;
  clearSelection: () => void;
}

export type RowActionsSlot<TRow extends Record<string, any> = Record<string, any>> = (
  row: MRT_Row<TRow>,
  ctx: RowActionsSlotContext
) => RowActionDescriptor[];

export const resolveSlotRowActions = (
  slot: RowActionsSlot,
  row: MRT_Row<Record<string, any>>,
  ctx: RowActionsSlotContext & { closeMenu?: () => void }
): RowActionDescriptor[] => {
  const { standardActions, requestReload, clearSelection, closeMenu } = ctx;
  return slot(row, { standardActions, requestReload, clearSelection }).map((action) =>
    !closeMenu || standardActions.includes(action) // the standard handlers close the menu themselves
      ? action
      : {
          ...action,
          onClick: (event: MouseEvent) => {
            action.onClick(event);
            closeMenu();
          },
        }
  );
};
